import script from "./ActivitiesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivitiesTable.vue?vue&type=script&setup=true&lang=js"

import "./ActivitiesTable.vue?vue&type=style&index=0&id=4c71fda1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c71fda1"]])

export default __exports__